import { configStore, globalStore } from "@/store/store";
import { CompletionContext, CompletionResult } from "@codemirror/autocomplete";
import { cssLanguage } from "@codemirror/lang-css";
import { syntaxTree } from "@codemirror/language";

function getBreakdanceSelectors(type: "TagName" | "ClassName" | "IdName") {
  return globalStore.cssSelectors
    .filter(selector => {
      if (type === "ClassName") {
        return selector.type === "class" || selector.name.startsWith(".");
      }

      if (type === "IdName") {
        return selector.type === "custom" || selector.name.startsWith("#");
      }

      return true;
    })
    .map(selector => ({
      type: "type",
      label:
        type === "ClassName" ? selector.name.replace(".", "") : selector.name,
      displayLabel: selector.name,
      section: "Breakdance Selectors"
    }));
}

function getOxySelectors(type: "TagName" | "ClassName" | "IdName") {
  return globalStore.oxySelectors
    .filter(selector => {
      if (type === "ClassName") {
        return selector.type === "class" || selector.name.startsWith(".");
      }

      if (type === "IdName") {
        return selector.name.startsWith("#");
      }

      return true;
    })
    .map(selector => ({
      type: "type",
      label: type === "ClassName" ? selector.name : `.${selector.name}`,
      displayLabel: type === "ClassName" ? `.${selector.name}` : selector.name,
      section: selector.collection
    }));
}

const identifier = /^(\w[\w-]*|-\w[\w-]*|)$/;

function completeCssSelectors(
  context: CompletionContext
): CompletionResult | null {
  const node = syntaxTree(context.state).resolveInner(context.pos, -1);

  if (
    node.name == "TagName" ||
    node.name == "ClassName" ||
    node.name == "IdName"
  ) {
    const selectors =
      configStore.builderMode === "breakdance"
        ? getBreakdanceSelectors(node.name)
        : getOxySelectors(node.name);

    for (let { parent } = node; parent; parent = parent.parent) {
      if (parent.name == "Block") {
        return {
          from: node.from,
          options: selectors,
          validFor: identifier
        };
      }
    }

    return {
      from: node.from,
      options: selectors,
      validFor: identifier
    };
  }

  return null;
}

export const cssSelectorsCompletions = cssLanguage.data.of({
  autocomplete: completeCssSelectors
});
